module.exports = __webpack_public_path__ + "img/isPro3_c2.8c5032a0.jpg";